"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityBox = void 0;
var React = require("react");
var _ = require("lodash");
var ActivityBox_style_1 = require("./ActivityBox.style");
var Icon_1 = require("../../Icon/Icon");
var helpers_1 = require("../../../helpers");
exports.ActivityBox = function (props) {
    var icon = props.icon, time = props.time, title = props.title, description = props.description, isDesktop = props.isDesktop, id = props.id, style = props.style, waterSaving = props.waterSaving, coins = props.coins;
    var renderSaving = function (value, type) {
        var suffix = function () {
            switch (type) {
                case "water":
                    return "L";
                default:
                    return "";
            }
        };
        var icon = function () {
            switch (type) {
                case "water":
                    return "droplet";
                case "coins":
                    return "coins";
                default:
                    return "";
            }
        };
        if (value) {
            return (React.createElement(ActivityBox_style_1.default.ValueWrap, null,
                React.createElement(Icon_1.default, { icon: icon(), size: 40, style: { marginRight: "4px" } }),
                "X",
                " ",
                helpers_1.prettifyIfNumber(value),
                " ",
                suffix()));
        }
        return null;
    };
    return (React.createElement(ActivityBox_style_1.default.ActivityBox, { style: style, "data-test": "ActivityBox", id: id ? "ActivityBox-" + id : null, isDesktop: isDesktop },
        isDesktop ? (React.createElement(ActivityBox_style_1.default.Icon, null,
            React.createElement(Icon_1.default, { icon: icon, size: 100 }))) : null,
        React.createElement(ActivityBox_style_1.default.ContentGroup, null,
            React.createElement(ActivityBox_style_1.default.Title, null, title),
            description ? (React.createElement(ActivityBox_style_1.default.Description, null, description)) : undefined,
            _.some([waterSaving, coins], Boolean) ? (React.createElement(ActivityBox_style_1.default.SavingWrap, null,
                waterSaving ? (React.createElement(ActivityBox_style_1.default.SavingGroup, null, renderSaving(waterSaving, "water"))) : undefined,
                coins ? (React.createElement(ActivityBox_style_1.default.SavingGroup, null, renderSaving(coins, "coins"))) : undefined)) : null,
            React.createElement(ActivityBox_style_1.default.Time, null, time))));
};
exports.default = exports.ActivityBox;
//# sourceMappingURL=ActivityBox.js.map